export default "__VITE_ASSET__DSYPO_X___"